import React from 'react';

const Contact = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h1>Contact Us</h1>
      <p>
        Welcome to Friendly4Kids! We are dedicated to creating a safe and friendly environment for kids to explore, learn, and grow. 
        Our mission is to connect families and communities through fun and educational activities.
      </p>
      <p>
        Whether you're looking for local events, activities, or resources, Friendly4Kids is here to help. 
        Thank you for being part of our community!
      </p>
    </div>
  );
};

export default Contact;